import { render, staticRenderFns } from "./ExternalSanoma.vue?vue&type=template&id=25778106&"
import script from "./ExternalSanoma.vue?vue&type=script&lang=js&"
export * from "./ExternalSanoma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports